<template>
  <div>
    <div class="toolbar">
      <h3>邀请码管理</h3>
      <el-button size="small" type="primary" @click="openCreate">新建邀请码</el-button>
    </div>

    <el-table v-loading="loading" :data="items" stripe>
      <el-table-column prop="code" label="邀请码" min-width="140" />
      <el-table-column label="次数上限" width="100">
        <template slot-scope="{ row }">{{ row.maxUses == null ? '不限' : row.maxUses }}</template>
      </el-table-column>
      <el-table-column prop="usedCount" label="已使用" width="90" />
      <el-table-column label="状态" width="90">
        <template slot-scope="{ row }">
          <el-tag :type="row.enabled ? 'success' : 'info'" size="mini">
            {{ row.enabled ? '启用' : '停用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" min-width="170" />
      <el-table-column label="操作" width="100" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="dialogMode === 'create' ? '新建邀请码' : '编辑邀请码'" :visible.sync="dialogVisible" width="420px">
      <el-form label-width="100px">
        <el-form-item v-if="dialogMode === 'create'" label="邀请码">
          <el-input v-model="form.code" placeholder="如 BETA2026" />
        </el-form-item>
        <el-form-item v-else label="邀请码">
          <el-input :value="form.code" disabled />
        </el-form-item>
        <el-form-item label="次数上限">
          <el-input v-model="form.maxUsesText" placeholder="留空表示不限" />
        </el-form-item>
        <el-form-item v-if="dialogMode === 'edit'" label="启用">
          <el-switch v-model="form.enabled" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="onSave">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { createInviteCode, fetchInviteCodes, updateInviteCode } from '../api/admin';

export default {
  name: 'InviteCodeList',
  data() {
    return {
      loading: false,
      saving: false,
      items: [],
      dialogVisible: false,
      dialogMode: 'create',
      form: {
        code: '',
        maxUsesText: '',
        usedCount: 0,
        enabled: true,
      },
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        this.items = await fetchInviteCodes();
      } catch (e) {
        this.$message.error(e.message || '加载失败');
      } finally {
        this.loading = false;
      }
    },
    openCreate() {
      this.dialogMode = 'create';
      this.form = { code: '', maxUsesText: '', usedCount: 0, enabled: true };
      this.dialogVisible = true;
    },
    openEdit(row) {
      this.dialogMode = 'edit';
      this.form = {
        code: row.code,
        maxUsesText: row.maxUses == null ? '' : String(row.maxUses),
        usedCount: row.usedCount,
        enabled: row.enabled,
      };
      this.dialogVisible = true;
    },
    parseMaxUses() {
      const text = (this.form.maxUsesText || '').trim();
      if (!text) return undefined;
      const n = Number(text);
      if (!Number.isInteger(n) || n < 1) {
        throw new Error('次数上限须为正整数');
      }
      return n;
    },
    async onSave() {
      this.saving = true;
      try {
        if (this.dialogMode === 'create') {
          if (!this.form.code || !this.form.code.trim()) {
            this.$message.warning('请输入邀请码');
            return;
          }
          await createInviteCode({
            code: this.form.code.trim(),
            maxUses: this.parseMaxUses(),
          });
          this.$message.success('已创建');
        } else {
          const maxUses = this.form.maxUsesText.trim() ? this.parseMaxUses() : null;
          await updateInviteCode(this.form.code, {
            maxUses,
            enabled: this.form.enabled,
          });
          this.$message.success('已保存');
        }
        this.dialogVisible = false;
        await this.load();
      } catch (e) {
        this.$message.error(e.message || '保存失败');
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped>
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.toolbar h3 { margin: 0; }
.hint { margin-left: 8px; font-size: 12px; color: #909399; }
</style>
